import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../provider/authProvider";

const useAboOwn = () => {

    const [ own, setOwn ] = useState(false);
    const authContext = useContext(AuthContext);

    useEffect(
        () => {

            if (!authContext.currentUserOverview.current) {
                setOwn(false);
            } else if (authContext.currentUserOverview.current.abo) {
                setOwn(true);
            }

         },
        [authContext.currentUserOverview.current]
    )

    return own;

}

export default useAboOwn;